import ModalMainWrapper from './ModalMainWrapper'
import ModalHeader from './ModalHeader'
import LoginForm from '../Auth/LoginForm'
import { ModalStore } from '../../state/ModalStore'

function LoginModal({ onSuccess }) {
    const skimModal = ModalStore((state) => state.skim)

    const handleSuccess = async (payload) => {
        await onSuccess?.(payload)
        skimModal()
    }

    return (
        <ModalMainWrapper>
            <div className="inline-block w-full max-w-[520px] overflow-hidden rounded-2xl bg-white text-left align-middle shadow-[0_24px_60px_rgba(26,29,35,0.18)]">
                <ModalHeader title="Sign in to your account" />
                <div className="px-6 py-6 sm:px-8">
                    <p className="mb-6 text-[14px] leading-[1.6] text-gray-500">
                        Log in without leaving this page. Your uploaded file and
                        mapping progress will stay right here.
                    </p>
                    <LoginForm onSuccess={handleSuccess} />
                </div>
            </div>
        </ModalMainWrapper>
    )
}

export default LoginModal
